import { getFirebaseAuth, hasFirebaseConfig } from './firebaseConfig';
import { saveUserToFirestore } from './userService';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as fbSignOut,
  onAuthStateChanged,
  updateProfile,
  sendPasswordResetEmail,
} from 'firebase/auth';

function auth() { return getFirebaseAuth(); }

function ensureConfigOrNull() {
  if (!hasFirebaseConfig()) return false;
  return true;
}

export function listenAuthState(callback) {
  if (!ensureConfigOrNull()) {
    // 即座に null を返し、unsubscribe ダミーを返却
    callback(null);
    return () => {};
  }
  return onAuthStateChanged(auth(), callback);
}

export async function register(email, password) {
  if (!ensureConfigOrNull()) throw new Error('Firebase未設定: register は利用できません');
  const cred = await createUserWithEmailAndPassword(auth(), email, password);
  // Firestoreのusersコレクションにも保存
  await saveUserToFirestore({
    uid: cred.user.uid,
    email: cred.user.email,
    displayName: cred.user.displayName || '',
    photoURL: cred.user.photoURL || ''
  });
  return cred.user;
}

export async function login(email, password) {
  if (!ensureConfigOrNull()) throw new Error('Firebase未設定: login は利用できません');
  const cred = await signInWithEmailAndPassword(auth(), email, password);
  // Firestoreのusersコレクションにも保存（なければ作成/更新）
  await saveUserToFirestore({
    uid: cred.user.uid,
    email: cred.user.email,
    displayName: cred.user.displayName || '',
    photoURL: cred.user.photoURL || ''
  });
  return cred.user;
}

export async function logout() {
  if (!ensureConfigOrNull()) return; // 何もしない
  await fbSignOut(auth());
}

export async function setDisplayName(displayName) {
  if (!ensureConfigOrNull()) return null;
  if (auth().currentUser) {
    await updateProfile(auth().currentUser, { displayName });
    try {
      // 最新を取得
      await auth().currentUser.reload();
    } catch(_) {}
    return auth().currentUser;
  }
  return null;
}

export async function requestPasswordReset(email) {
  if (!ensureConfigOrNull()) throw new Error('Firebase未設定: password reset は利用できません');
  await sendPasswordResetEmail(auth(), email, { url: window.location.origin + '/signin' });
  return true;
}
